const centsToAmount = (cents: number): number => {
  if (!cents) {
    return cents;
  }

  return cents / 100;
};

const amountToCents = (amount: number): number => {
  if (!amount) {
    return amount;
  }

  return Math.round(amount * 100);
};

export const AmountUtils = {
  centsToAmount,
  amountToCents,
};
